import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { CtaButton } from '../CtaButton';
import { stages } from '../../data/landing';
export function Framework() {
  return <section className="w-full bg-white px-4 py-16 sm:px-6 lg:py-24" aria-labelledby="framework-title" data-id="element-150" data-mp="28yq31shkvki4">
      <div className="mx-auto max-w-6xl" data-id="element-151" data-mp="2dxko7130pl5e">
        <SectionHeading title={<span id="framework-title" data-id="element-153" data-mp="2dznn6am5eom9">Meet the <span className="text-brand" data-id="element-154" data-mp="1z8epde83dwy1">Clear Aligner Clinical Blueprint™</span></span>} subtitle="A structured six-stage framework for organizing your clear aligner case-planning workflow." data-id="element-152" data-mp="2dwjdwyttt2oq" />
        <div className="mx-auto mt-6 max-w-2xl space-y-4 text-center text-base leading-relaxed text-ink-muted sm:text-lg" data-id="element-155" data-mp="1q91gonrslced">
          <p data-id="element-156" data-mp="1v7ut0cvcexcy">
            I created the Clear Aligner Clinical Blueprint™ as an educational resource for dental professionals who want a more organized way to approach the information involved in clear aligner treatment planning.
          </p>
          <p data-id="element-157" data-mp="2yyulrb3mqfhl">Instead of presenting disconnected tips and isolated concepts, this collection organizes the process into six connected stages.</p>
        </div>

        <h3 className="mt-12 text-center font-display text-lg font-extrabold uppercase tracking-wide text-navy sm:text-xl" data-id="element-158" data-mp="2tz8850jw2x89">The six-stage clinical framework</h3>

        <ol className="relative mx-auto mt-8 max-w-2xl lg:grid lg:max-w-none lg:grid-cols-3 lg:gap-x-10 lg:gap-y-12" data-id="element-159" data-mp="33xecrpx2yhgt">
          {stages.map((s, i) => <li key={s.n} className="relative flex gap-4 pb-8 last:pb-0 lg:flex-col lg:gap-3 lg:pb-0" data-id="element-160" data-mp="2g68vd6bhrh4e" data-mpi={i}>
              {i < stages.length - 1 && <span className="absolute left-[27px] top-14 h-[calc(100%-56px)] w-0.5 bg-navy/10 lg:hidden" aria-hidden="true" data-id="element-161" data-mp="2p0wyoqxiaoqk" />}
              <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl font-display text-xl font-extrabold text-white" style={{
            backgroundColor: s.color
          }} data-id="element-162" data-mp="2k8napgfybyqx">
                {s.n}
              </span>
              <div className="pt-1 lg:pt-0" data-id="element-163" data-mp="3rmzf6fvfhtoe">
                <h4 className="font-display text-2xl font-extrabold uppercase tracking-tight" style={{
              color: s.color
            }} data-id="element-164" data-mp="gy1s0nzqnzl">
                  {s.title}
                </h4>
                <p className="mt-1.5 text-base leading-relaxed text-ink-muted" data-id="element-165" data-mp="5a0xaecbw7if">{s.text}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-12 max-w-2xl text-center text-base font-semibold leading-relaxed text-navy sm:text-lg" data-id="element-166" data-mp="38pg5rb52691g">
          Each stage connects with the next, creating a repeatable educational framework for reviewing cases in a more systematic manner.
        </p>

        <CtaButton label="Get the complete Blueprint for $27" className="mt-8" data-id="element-167" data-mp="3nlxc1nye4xh5" />
      </div>
    </section>;
}